import { openRemoteModal } from '@js/utilities/remoteModal';

window.addEventListener('forms.success.issueFormCallback', () => {
    const issueForm = document.querySelector('#issue-form');

    issueForm?.reset();
    issueForm?.multiStepForm?.go(1);

    openRemoteModal(`/ajax/modals/success/issue-form`);
});
